export interface PdfDialogData {
  title: string;
  download: string;
  button: string;
  url?: string;
}

export interface PdfDialogDataResult {
  action: PDF_ACTIONS;
}

export enum PDF_ACTIONS {
  OK = 'OK'
}
